import type { FC } from 'react';
import { QBox } from '../../QLayouts';
import { QIconButton } from '../../QAtoms';
import { useLibraryTranslation } from '../../i18n';

export type QReorderButtonsProps = {
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
};

/**
 * Up and down buttons for reordering items.
 *
 * @see QReorderableCardStack
 */
export const QReorderButtons: FC<QReorderButtonsProps> = ({
  onMoveUp,
  onMoveDown,
  canMoveUp = true,
  canMoveDown = true,
}) => {
  const { t } = useLibraryTranslation();
  return (
    <QBox>
      <QIconButton
        aria-label={t('reorderButtons.moveUp')}
        iconName="ArrowUp"
        onClick={onMoveUp}
        isDisabled={!canMoveUp}
        size="sm"
      />
      <QIconButton
        aria-label={t('reorderButtons.moveDown')}
        iconName="ArrowDown"
        onClick={onMoveDown}
        isDisabled={!canMoveDown}
        size="sm"
      />
    </QBox>
  );
};
QReorderButtons.displayName = 'QReorderButtons';
